import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import { PopoverPaper } from 'src/components';
import styles from './HelpAndSupport.module.scss';
import useAuthorizationContext from 'src/providers/AuthorizationHandler/useAuthorizationContext';
import { HelpAndSupportVaribles } from 'src/constants/constVariables';

export const HelpAndSupport = ({ open, handleClose, anchorEl }) => {
	const { user, logoutUser } = useAuthorizationContext();
	return (
		<PopoverPaper
			open={open}
			handleClose={handleClose}
			anchorEl={anchorEl}
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'right',
			}}
		>
			<div className={styles.display}>
				<div className={styles.iconContainer}>
					<PersonOutlineOutlinedIcon
						color="info"
						className={styles.personIcon}
					/>
				</div>
				<div className={styles.details}>
					<span className={styles.name}>TML SPOC</span>
					<span className={clsx(styles.email)}>
						{HelpAndSupportVaribles.tml_spoc_name}
					</span>
					<span className={clsx(styles.email)}>
						{HelpAndSupportVaribles.tml_spoc_email}
					</span>
					<span className={clsx(styles.email)}>
						{HelpAndSupportVaribles.tml_spoc_contact}
					</span>
				</div>
			</div>
		</PopoverPaper>
	);
};

HelpAndSupport.propTypes = {
	open: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	anchorEl: PropTypes.instanceOf(Element),
};
